import { useTranslation } from 'react-i18next';

import { Profile } from '../../../models/UserStore';
import { AvatarNode } from '../../Molecules';
import { BasicPopupContainer } from '../Containers/BasicPopupContainer';

import styles from './ConfirmReferralPopup.module.css';

type ConfirmReferralPopup = {
  profile: Profile;
  onPrimary: () => void;
  onCancel: () => void;
};
export const ConfirmReferralPopup = (props: ConfirmReferralPopup) => {
  const { profile, onPrimary, onCancel } = props;
  const { t } = useTranslation();

  const name = profile.name;

  return (
    <BasicPopupContainer
      onPrimaryButtonClick={onPrimary}
      primaryButtonLabel={t('Continue')}
      onSecondaryButtonClick={onCancel}
    >
      <div className={styles.container}>
        <div className={styles.iconContainer}>
          <AvatarNode profile={profile} size={80} />
        </div>
        <div className={styles.titleContainer}>
          <p className={styles.title}>{name}</p>
        </div>
        <div className={styles.contentContainer}>
          <div className={styles.text}>
            {t(
              `You are being referred by this user, who will receive referral rewards.`,
            )}
          </div>
        </div>
      </div>
    </BasicPopupContainer>
  );
};
